import React, { useEffect } from 'react';
import { Button, Grid, Card } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import successgif from '../../assets/images/successgif.gif'
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import NewNavBar from '../../components/NewNavBar/NewNavBar';
import Sidebar from '../../components/Sidebar/Sidebar';
const PaymentSuccess = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })
    const navigate = useNavigate();
    const handleClickHistory = () => {
        navigate('/history');
    }
    return (
        <>
            <Header />
            <NewNavBar />
            <Sidebar className='sidebartoggle' />
            <div
                className="container-fluid"
                style={{
                    backgroundColor: '#f6f6f6',
                    width: '100%',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Card
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 4,
                        borderRadius: 2,
                        minHeight: 420,
                        width: '100%',
                        maxWidth: 400,
                        boxShadow: 3,
                    }}
                >
                    <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <Grid item>
                            <img style={{ height: '200px', width: '200px', borderRadius: '15px' }} src={successgif} ></img>
                        </Grid>
                        <Grid item>
                            <div style={{ color: 'greenyellow', fontSize: '24px', fontWeight: '600', textAlign: 'center' }}>Thank You!</div>
                            <div style={{ fontSize: '16px', marginTop: '8px' }}>Payment done Successfully!!!</div>
                        </Grid>
                        <Grid item style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <div>Click here to go to history page.</div>
                            <Button onClick={handleClickHistory}>History</Button>
                        </Grid>
                    </Grid>
                </Card>
            </div>
            <Footer />
        </>
    );
};

export default PaymentSuccess;
